<template>
  <DialogTeamSelect
    v-model="teamDialog"
    description="Choose your active team"
    v-bind:title="'Join \'' + quizName + '\''"
    @ok="joinQuiz"
  ></DialogTeamSelect>
</template>

<script>
import DialogTeamSelect from "@/components/DialogTeamSelect";

export default {
  name: "Join",
  components: {
    DialogTeamSelect
  },
  data() {
    return {
      teamDialog: false,
      quizID: 0,
      quizName: ""
    };
  },
  created() {
    var code = this.$route.params.code;
    localStorage.setItem("JoinIntent", code);

    this.$topquiz.checkSession(
      () => {
        this.$topquiz.sendCommand(
          "checkJoinIntent",
          this.$topquiz.SessionKey,
          code
        );
      },
      () => {
        this.$router.replace("/login");
      }
    );

    this.$topquiz.on(this, "checkJoinIntent_success", params => {
      this.quizID = params[0].id;
      this.quizName = params[0].name;
      this.teamDialog = true;
    });

    this.$topquiz.on(this, "join_success", params => {
      this.quizID = params[0];
      this.$router.replace("/play/" + this.quizID);
    });
  },
  destroyed() {
    this.$topquiz.unsubscribe(this);
  },
  methods: {
    joinQuiz() {
      var activeTeam = this.$store.state.teamStore.activeTeam;
      if (!activeTeam) {
        this.$router.replace("/dashboard");
        return;
      }

      this.$topquiz.sendCommand(
        "join",
        this.$topquiz.SessionKey,
        this.quizID,
        activeTeam.id
      );
    }
  }
};
</script>
